// @flow
import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared'
import { OutlineOnFocusVisible } from '@components/shared/buttons'

const Radio = (props: {
  value: string,
  name: string,
  isActive: boolean,
  groupName: string,
  formId: string,
  checkColor?: string
}): React.Node => {
  const radioRef = React.useRef(null)
  const handleKeyDown = (): void => {
    return radioRef.current?.click()
  }

  return (
    <Label
      className='radio-label'
      isActive={props.isActive}
      tabIndex='0'
      aria-checked={props.isActive}
      onKeyDown={(event: any): void => {
        if (event.keyCode === 13) {
          handleKeyDown()
        }
      }}
    >
      <Input
        ref={radioRef}
        type='radio'
        id={props.value}
        name={props.name}
        value={props.value}
        groupName={props.groupName}
        form={props.formId}
      />

      {props.isActive && <CheckCicleSvg />}
    </Label>
  )
}

export default Radio

const CheckCicleSvg = (): React.Node => {
  return (
    <svg
      width='10'
      height='10'
      viewBox='0 0 10 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='5' cy='5' r='5' fill='white' />
    </svg>
  )
}

const Input = styled.input`
  display: none;
  position: absolute;
  visibility: hidden;
`

const Label = styled.label`
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.white};
  height: 22px;
  width: 22px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  ${OutlineOnFocusVisible};
`
